module.exports = __webpack_public_path__ + "static/img/IMG_20240326_193610.166353b0.jpg";